import React from 'react';
import { Hero } from './components/sections/Hero';
import { Pain } from './components/sections/Pain';
import { Demo } from './components/sections/Demo';
import { Inside } from './components/sections/Inside';
import { Benefits } from './components/sections/Benefits';
// import { Reviews } from './components/sections/Reviews'
import { Order } from './components/sections/Order';
import { Bonuses } from './components/sections/Bonuses';
import { Guarantee } from './components/sections/Guarantee';
import { Delivery } from './components/sections/Delivery';
import { Faq } from './components/sections/Faq';
import { Close } from './components/sections/Close';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-bg text-ink" data-id="element-0" data-mp="2wifhhi6tdh0t">
      <main data-id="element-1" data-mp="28u5xmlt5v3cb">
        <Hero data-id="element-2" data-mp="28tw9l3rof699" />
        <Pain data-id="element-3" data-mp="28te2fc3h77mk" />
        <Demo data-id="element-4" data-mp="28sutulzptvl7" />
        <Inside data-id="element-5" data-mp="28sl0cofgp6ar" />
        <Benefits data-id="element-6" data-mp="28s30zixi6bym" />
        <Order data-id="element-7" data-mp="23vkzcrxgytqi" />
        <Guarantee data-id="element-8" data-mp="23w4ek0vqj40u" />
        <Bonuses data-id="element-9" data-mp="23ujha3i1d6za" />
        <Delivery data-id="element-10" data-mp="23v2u55stx56g" />
        {/* Reviews temporarily hidden until the real review copy is ready */}
        {/* <Reviews /> */}
        <Faq data-id="element-11" data-mp="3mlj8uuvtnd32" />
        <Close data-id="element-12" data-mp="3ml13n8r6loj0" />
      </main>
      <Footer data-id="element-13" data-mp="3mk868ye44bdj" />
    </div>;
}